export const white = '#FFFFFF';
export const black = '#000000';

export const grey = {
    50: '#F9FAFB',
    100: '#F3F4F6',
    200: '#E5E7EB',
    300: '#D1D5DB',
    400: '#9CA3AF',
    500: '#6B7280',
    600: '#4B5563',
    700: '#374151',
    800: '#1F2937',
    900: '#111827',
    950: '#030712',
};

export const navy = {
    50: '#F0F4FF',
    100: '#E5EDFF',
    200: '#CCDCFF',
    300: '#99BDFF',
    400: '#6691FF',
    500: '#3366FF',
    600: '#1939B7',
    700: '#132C8F',
    800: '#0C1F66',
    900: '#061333',
};

export const autohost = {
    50: '#fbe2ff',
    100: '#f2b7fe',
    200: '#e982fe',
    300: '#de3bff',
    400: '#d500ff',
    500: '#c400f2',
    600: '#b100ee',
    700: '#9500e9',
    800: '#7c00e4',
    900: '#4000da',
};

export const autohostBlue = {
    50: '#e3f0f6',
    100: '#bbd9eb',
    200: '#93c2de',
    300: '#6eaad0',
    400: '#5599c8',
    500: '#3f89c0',
    600: '#367cb4',
    700: '#2c6ca3',
    800: '#245c91',
    900: '#174072',
};

// Success color: Professional green
export const green = {
    50: '#F0FDF4',
    100: '#DCFCE7',
    200: '#BBF7D0',
    300: '#86EFAC',
    400: '#4ADE80',
    500: '#22C55E',
    600: '#16A34A',
    700: '#15803D',
    800: '#166534',
    900: '#14532D'
};

// Warning color: Refined orange
export const orange = {
    50: '#FFF7ED',
    100: '#FFEDD5',
    200: '#FED7AA',
    300: '#FDBA74',
    400: '#FB923C',
    500: '#F97316',
    600: '#EA580C',
    700: '#C2410C',
    800: '#9A3412',
    900: '#7C2D12'
};

// Error color: Professional red
export const red = {
    50: '#FEF2F2',
    100: '#FEE2E2',
    200: '#FECACA',
    300: '#FCA5A5',
    400: '#F87171',
    500: '#EF4444',
    600: '#DC2626',
    700: '#B91C1C',
    800: '#991B1B',
    900: '#7F1D1D'
};

export const primary = {
    light: '#F6F9FD',
    main: navy[600],
    dark: navy[800],
    contrastText: white,
};

export const secondary = {
    light: '#f9f9f9',
    main: autohost[500],
    dark: autohost[800],
    contrastText: white,
};

export const info = {
    light: '#F1FBFC',
    main: autohostBlue[500],
    dark: autohostBlue[800],
    contrastText: white,
};

export const success = {
    light: '#F1FAF5',
    main: green[600],
    dark: green[800],
    contrastText: white,
};

export const warning = {
    light: '#FDF8F3',
    main: orange[600],
    dark: orange[800],
    contrastText: white,
};

export const danger = {
    light: '#FEF6F6',
    main: red[600],
    dark: red[800],
    contrastText: white,
}